import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UserDetails from "../components/user-details";

const EditUser = ({ selectedUser, redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/user/edit") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <UserDetails userData={selectedUser} />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

EditUser.defaultProps = {
  selectedUser: null,
  redirectTo: "",
};

EditUser.propTypes = {
  selectedUser: PropTypes.objectOf(PropTypes.any),
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state, { location }) => {
  const targetId = location.state?.userId;
  const allUsers = Array.isArray(state?.data?.userData) ? state.data.userData : [];
  const foundUser = allUsers.find((user) => user.id === targetId);

  return {
    selectedUser: foundUser,
    redirectTo: state.ui.redirectTo,
  };
};

export default connect(mapStateToProps, null)(EditUser);
